export function IconOverviewVerDesk() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
    </svg>
  );
}
export function IconOverviewVerDash({ color = "#797979" }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 9 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.242188"
        y="0.199219"
        width="2.50242"
        height="11.8865"
        fill={color}
      />
      <rect
        x="3.37012"
        y="6.45508"
        width="2.50242"
        height="5.63044"
        fill={color}
      />
      <rect
        x="6.49805"
        y="3.32715"
        width="2.50242"
        height="8.75846"
        fill={color}
      />
    </svg>
  );
}

export function IconOverviewUnreadChat() {
  return (
    <div className="relative">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-azul-400"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
      <span className="absolute -top-0.5 -right-0.5 flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
      </span>
    </div>
  );
}

interface TarefasCount {
  pendentes: number;
  emAndamento: number;
  concluidas: number;
  total: number;
}

interface IconOverviewTarefasProps {
  tarefasCount: TarefasCount;
  onClick: () => void;
}

export function IconOverviewTarefas({
  tarefasCount,
  onClick,
}: IconOverviewTarefasProps) {
  const hasTasks = tarefasCount?.total > 0;
  const hasPendingOrInProgress =
    (tarefasCount?.pendentes ?? 0) > 0 || (tarefasCount?.emAndamento ?? 0) > 0;

  return (
    <div className="relative group">
      <button
        onClick={onClick}
        className={`${hasTasks ? "text-azul-400" : "text-cinza-300"}`}
        title="Ver tarefas"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
        </svg>
        {hasPendingOrInProgress && (
          <span className="absolute -top-0.5 -right-0.5 flex h-2 w-2">
            <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
          </span>
        )}
      </button>
      <div className="absolute right-full top-1/2 -translate-y-1/2 mr-2 px-3 py-2 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 whitespace-nowrap">
        <div className="text-xs space-y-1">
          <p className="font-semibold text-cinza-800 border-b pb-1 mb-1">
            Tarefas
          </p>
          <p className="flex justify-between gap-4">
            <span className="text-amber-500">Pendentes:</span>
            <span className="font-medium">{tarefasCount?.pendentes ?? 0}</span>
          </p>
          <p className="flex justify-between gap-4">
            <span className="text-azul-400">Em andamento:</span>
            <span className="font-medium">
              {tarefasCount?.emAndamento ?? 0}
            </span>
          </p>
          <p className="flex justify-between gap-4">
            <span className="text-verde-300">Concluídas:</span>
            <span className="font-medium">{tarefasCount?.concluidas ?? 0}</span>
          </p>
          <p className="flex justify-between gap-4 border-t pt-1 mt-1">
            <span className="text-cinza-800 font-medium">Total:</span>
            <span className="font-medium">{tarefasCount?.total ?? 0}</span>
          </p>
        </div>
        <div className="absolute left-full top-1/2 -translate-y-1/2 -ml-1">
          <div className="border-4 border-transparent border-l-white"></div>
        </div>
      </div>
    </div>
  );
}
